import Parse from "parse";
import { env } from "../env/config";

let initialized = false;

export const initParse = () => {
  if (initialized) {
    return;
  }

  Parse.initialize(env.appId);
  Parse.serverURL = env.serverUrl;
  initialized = true;
};

export { Parse };
